// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".m9msq9wxrAeHJoEznOP5{display:flex;justify-content:center;height:100%;width:100%;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"htmlCreativeWrapper": "m9msq9wxrAeHJoEznOP5"
};
export default ___CSS_LOADER_EXPORT___;
